import { useLocation } from "@tanstack/react-router";
import { SidebarContent } from "./SidebarContent";
import { useSidebarData } from "./useSidebarData";
import { useScrollActiveNavIntoView } from "./sidebar/scroll-active-into-view";

export function Sidebar() {
  const { identity, role, visibleGroups, pendingCount, customerBookingPendingCount, chatWaitingCount, notificationUnreadCount } =
    useSidebarData();
  // Khoá theo cả search (?tab=…) chứ không chỉ đường dẫn: /retouch và /cskh có
  // nhiều mục menu cùng trỏ một trang, khác nhau đúng ở tab.
  const { pathname, searchStr } = useLocation();
  const scrollerRef = useScrollActiveNavIntoView<HTMLElement>(`${pathname}${searchStr}`);

  return (
    <aside
      ref={scrollerRef}
      className="sticky top-0 hidden h-full w-[260px] shrink-0 flex-col overflow-y-auto scrollbar-on-brand md:flex"
      style={{ background: "var(--gn-sidebar-bg)", color: "rgba(255,255,255,0.75)" }}
    >
      <SidebarContent
        identity={identity}
        role={role}
        visibleGroups={visibleGroups}
        pendingCount={pendingCount}
        customerBookingPendingCount={customerBookingPendingCount}
        chatWaitingCount={chatWaitingCount}
        notificationUnreadCount={notificationUnreadCount}
      />
    </aside>
  );
}
